module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc1"
  }, [_c('h1', {
    staticClass: "chapter"
  }, [_c('span', {
    staticStyle: {
      "color": "white",
      "font-size": "xx-large"
    }
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/for.htm",
      "id": "for"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/int.htm",
      "id": "int"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ever.htm",
      "id": "ever"
    }
  }, [_vm._v("Everything Corn")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c01.htm",
      "id": "c01"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_c('strong', [_vm._v("BREAKFAST")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c02.htm",
      "id": "c02"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_c('strong', [_vm._v("SOUPS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c03.htm",
      "id": "c03"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_c('strong', [_vm._v("STARTERS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c04.htm",
      "id": "c04"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_c('strong', [_vm._v("MAINS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c05.htm",
      "id": "c05"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_c('strong', [_vm._v("SIDES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c06.htm",
      "id": "c06"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_c('strong', [_vm._v("SWEETS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/contri.htm",
      "id": "contri"
    }
  }, [_vm._v("Contributors’ Biographies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ata.htm",
      "id": "ata"
    }
  }, [_vm._v("About The Dougy Center")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ack.htm",
      "id": "ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/matri.htm",
      "id": "matri"
    }
  }, [_vm._v("Metric Conversions and Equivalents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ind.htm",
      "id": "ind"
    }
  }, [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/viii.png"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-349bca82","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/toc.vue
// module id = 66
// module chunks = 0